module.exports = __webpack_public_path__ + "static/media/instructivo5.c949c76e.png";